import React, { Fragment, useMemo, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

import Backdrop from "../Backdrop/Backdrop.jsx";
import Modal from "../Modal/Modal.jsx";
import UploadedFileUseContent from '../UploadedFileUseContent/UploadedFileUseContent.jsx';

import { useStore } from "../../hook-store/store.js";

import { marks } from "../../utils/marks.jsx";
import "./PdfToText.css";

let pdfViewEl

export default function PdfToTextFileSelect(props) {
    const { 
      inputPdfFile,
      setInputPdfFile,
      pdfReadHandler,
      isLoading,
    } = props;


    const [t] = useTranslation("translation");

    const hiddenFileSelect = useRef(null);
    
    const [store, dispatch] = useStore();
    const { 
      paramFileDataList,
    } = store.uiStore;

    const [showModalUseUploadedFile, setShowModalUseUploaded] = useState(false);

    useEffect(() => {
      if (!inputPdfFile && paramFileDataList && paramFileDataList.files?.length > 0 &&
            paramFileDataList.openApp === 'pdfToText'
      ) {
        pdfReadHandler(paramFileDataList.files[0]);
        dispatch('SET_PARAMFILEDATALIST', null);
      }
  
    },[paramFileDataList]);


    const handleInputClick = (event) => {
      console.log('clicked')
      hiddenFileSelect.current.click()
    };

    const setInputPdfFileHandler = (event) => {
      const file = event.target.files[0];
      console.log('file', file);
      if (file.type === 'application/pdf') {
        // setInputPdfFile(event.target.files[0]);
        pdfReadHandler(file);
      } 
    }

    let pdfToTextFileSelectBody;

    pdfToTextFileSelectBody = (
      <div>
        <div className="pdfToTextRow">
          <input 
            style={{display: 'none'}}
            type="file"
            ref={hiddenFileSelect}
            accept="application/pdf"
            onChange={setInputPdfFileHandler}
          />
          <div className="pdfToTextFileSelectButtons">
            <button className="btnBase"
              style={{border:"0.5px solid gray", borderRadius: "4px"}}
              disabled={isLoading} 
              onClick={handleInputClick}
            >
              {marks.filePdfOMark}{' '}
              {t('pdfToText03', 'Select pdf file')}
            </button>
            <button className="btnBase"
              style={{border:"0.5px solid gray", borderRadius: "4px"}}
              // disabled={isLoading} 
              onClick={() => { 
                setShowModalUseUploaded(true); 
              }}
            >
              {marks.downloadMark}{' '}
              {t('audioEditor03', 'Uploaded file')} 
            </button>
          </div>
        </div>

        {showModalUseUploadedFile && (
          <div>
            <Backdrop 
              zIndex={'95'}
              onCancel={() => { 
                setShowModalUseUploaded(false);
              }}
            />
            <Modal
              onClose={() => {
                setShowModalUseUploaded(false);
              }}
            >
              <UploadedFileUseContent
                setShowModalUseUploaded={setShowModalUseUploaded}
              />
            </Modal>
          </div>
        )}
       
      </div>
    );

    return (
        <Fragment>
          <div>{pdfToTextFileSelectBody}</div>
        </Fragment>
    );
  };
